module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-76x76-ff7be159b4d1485f4641dcd4ff396bfb.png";